/**
 * Tema Mantine da Folha SilliS (U1): primária = verde SilliS (#14532d, o verde
 * histórico do app), fonte = system stack (sem download de fonte — Inter ficaria
 * para quando houver bundling de fontes), pt-BR. U5: o CSS próprio legado foi
 * removido — tudo é Mantine (+ wrappers finos em componentes/entradas-mantine).
 */
import { createTheme, type MantineColorsTuple } from "@mantine/core";

/** Escala derivada do verde SilliS #14532d (índice 7 = cor base). */
const VERDE_SILLIS: MantineColorsTuple = [
  "#eef7f0",
  "#d9ecdf",
  "#b5d9c3",
  "#8cc6a4",
  "#63b388",
  "#45a271",
  "#2f8f5d",
  "#14532d", // base — verde SilliS
  "#0f4526",
  "#09331c",
];

export const tema = createTheme({
  primaryColor: "sillis",
  primaryShade: 7,
  colors: { sillis: VERDE_SILLIS },
  fontFamily: 'system-ui, "Segoe UI", Arial, sans-serif',
  defaultRadius: "md",
  headings: { fontWeight: "700" },
});
